import * as types from 'constants/ActionTypes';

import i18n from 'i18n';

const initState = {
  srsBranchEmployee: {
    srsBranchEmployeeInfo: {
      srsCustId: '',
      srsShipNumber: '',
    },
    srsBranchEmployeeInfoErrors: {
      srsCustId: '',
      srsShipNumber: '',
    },
    srsBranchEmployeeInfoErrorsForDisplay: {
      srsCustId: '',
      srsShipNumber: '',
    },
    srsBranchEmployeeInfoErrorsForBanner: {
      srsCustId: '',
      srsShipNumber: '',
    },
    srsBranchEmployeeInfoErrorsForBannerDisplay: {
      srsCustId: '',
      srsShipNumber: '',
    },
  },
  srsValidation: {
    checked: false,
    isLoading: false,
    isError: false,
    showSuccess: false,
    customerVerified: false,
    srsValidationInfo: null,
    srsValidationError: '',
  },
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_ERROR: return {
      ...state,
      srsValidation: {
        isLoading: false, isError: true, checked: true, srsValidationInfo: null,
      },
    };
    case types.UPDATE_SRS_BRANCH_EMPLOYEE_INFO: return {
      ...state,
      srsBranchEmployee: {
        ...state.srsBranchEmployee,
        srsBranchEmployeeInfo: {
          ...state.srsBranchEmployee.srsBranchEmployeeInfo,
          [action.field]: action.value,
        },
      },
    };
    case types.UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO: {
      const srsBranchEmployeeInfoErrorsUpdated = { ...state.srsBranchEmployee.srsBranchEmployeeInfoErrors };
      srsBranchEmployeeInfoErrorsUpdated[action.fieldId] = action.fieldErrorValue;

      const srsBranchEmployeeInfoErrorsForBannerUpdated = { ...state.srsBranchEmployee.srsBranchEmployeeInfoErrorsForBanner };
      srsBranchEmployeeInfoErrorsForBannerUpdated[action.fieldId] = action.bannerErrorValue;

      return {
        ...state,
        srsBranchEmployee: {
          ...state.srsBranchEmployee,
          srsBranchEmployeeInfoErrors: { ...srsBranchEmployeeInfoErrorsUpdated },
          srsBranchEmployeeInfoErrorsForBanner: { ...srsBranchEmployeeInfoErrorsForBannerUpdated },
        },
      };
    }
    case types.VALIDATE_SRS_BRANCH_EMPLOYEE_RESET: return {
      ...state,
      srsValidation: {
        isLoading: false, isError: false, checked: false, showSuccess: false, srsValidationInfo: null, srsValidationError: '',
      },
    };
    // #genai - Both validation flows share the same loading-state transition.
    case types.VALIDATE_SRS_BRANCH_EMPLOYEE_START:
    case types.VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_START: return {
      ...state,
      srsValidation: { isLoading: true, isError: false, srsValidationInfo: null },
    };
    case types.VALIDATE_SRS_BRANCH_EMPLOYEE_SUCCESS: return {
      ...state,
      srsBranchEmployee: {
        ...state.srsBranchEmployee,
        srsBranchEmployeeInfoErrors: {
          srsCustId: '',
          srsShipNumber: '',
        },
        srsBranchEmployeeInfoErrorsForDisplay: {
          srsCustId: '',
          srsShipNumber: '',
        },
        srsBranchEmployeeInfoErrorsForBanner: {
          srsCustId: '',
          srsShipNumber: '',
        },
        srsBranchEmployeeInfoErrorsForBannerDisplay: {
          srsCustId: '',
          srsShipNumber: '',
        },
      },
      srsValidation: {
        isLoading: false, isError: false, checked: true, showSuccess: true, customerVerified: true, srsValidationInfo: action.srsValidationInfo,
      },
    };
    case types.VALIDATE_SRS_BRANCH_EMPLOYEE_ERROR: return {
      ...state,
      srsValidation: {
        isLoading: false,
        isError: true,
        checked: true,
        showSuccess: false,
        customerVerified: false,
        srsValidationInfo: null,
        srsValidationError: action.error,
      },
    };
    case types.VALIDATE_SRS_BRANCH_EMPLOYEE_HIDE_SUCCESS_BANNER: return {
      ...state,
      srsValidation: {
        ...state.srsValidation,
        isLoading: false,
        isError: false,
        checked: true,
        showSuccess: false,
        customerVerified: true,
      },
    };
    case types.UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO_FOR_DISPLAY: return {
      ...state,
      srsBranchEmployee: {
        ...state.srsBranchEmployee,
        srsBranchEmployeeInfoErrorsForDisplay: {
          ...state.srsBranchEmployee.srsBranchEmployeeInfoErrors,
        },
        srsBranchEmployeeInfoErrorsForBannerDisplay: {
          ...state.srsBranchEmployee.srsBranchEmployeeInfoErrorsForBanner,
        },
      },
    };
    case types.UPDATE_SRS_BRANCH_EMPLOYEE_EMPTY_SUBMISSION: {
      const { srsBranchEmployeeInfo } = state.srsBranchEmployee;
      if (state.srsBranchEmployee.srsBranchEmployeeInfo.srsCustId === '' && state.srsBranchEmployee.srsBranchEmployeeInfo.srsShipNumber === '') {
        return {
          ...state,
          srsBranchEmployee: {
            ...state.srsBranchEmployee,
            srsBranchEmployeeInfoErrorsForDisplay: {
              srsCustId: i18n.t('common__field_required'),
              srsShipNumber: i18n.t('common__field_required'),
            },
            srsBranchEmployeeInfoErrorsForBannerDisplay: {
              srsCustId: i18n.t('order__srs_branch_employee__customer_id_required'),
              srsShipNumber: i18n.t('order__srs_branch_employee__ship_number_required'),
            },
          },
        };
      }
      // #genai - Keep each independent validation branch on its own line.
      if (srsBranchEmployeeInfo.srsCustId === '') {
        return {
          ...state,
          srsBranchEmployee: {
            ...state.srsBranchEmployee,
            srsBranchEmployeeInfoErrorsForDisplay: {
              srsCustId: i18n.t('common__field_required'),
              srsShipNumber: '',
            },
            srsBranchEmployeeInfoErrorsForBannerDisplay: {
              srsCustId: i18n.t('order__srs_branch_employee__customer_id_required'),
              srsShipNumber: '',
            },
          },
        };
      }
      if (srsBranchEmployeeInfo.srsShipNumber === '') {
        return {
          ...state,
          srsBranchEmployee: {
            ...state.srsBranchEmployee,
            srsBranchEmployeeInfoErrorsForDisplay: {
              srsCustId: '',
              srsShipNumber: i18n.t('common__field_required'),
            },
            srsBranchEmployeeInfoErrorsForBannerDisplay: {
              srsCustId: '',
              srsShipNumber: i18n.t('order__srs_branch_employee__ship_number_required'),
            },
          },
        };
      }
      return state;
    }
    case types.VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_SUCCESS: return {
      ...state,
      srsValidation: {
        isLoading: false, isError: false, checked: true, srsValidationInfo: action.srsValidationInfo,
      },
    };
    // #genai These actions intentionally share the same complete SRS reset transition.
    case types.VALIDATE_SRS_BRANCH_EMPLOYEE_INFO_RESET:
    case types.PLACE_ORDER_SUCCESS:
    case types.CANCEL_ORDER_SELECTION: return {
      ...state,
      srsBranchEmployeeInfo: { ...initState.srsBranchEmployeeInfo },
      srsValidation: { ...initState.srsValidation, accountNumber: null },
    };
    default:
      return state;
  }
};
